import UserForm, { UserFormData } from "@/Components/Forms/UserForm";
import { useCreateUser } from "@/Service/Api/V1/ApiHooks/Users/useCreateUser";
import { useQueryClient } from "@tanstack/react-query";
import { useToastMessagesStore } from "@/Stores/ToastMessagesStore";
import { QueryKeys } from "@/Service/Api/V1/QueryKeys/QueryKeys";
import PageLayout from "@/Themes/Default/Layouts/PageLayout";
import { can } from "@/Util/permissionChecks";
import {sleep, url} from "@/Helpers/general";
import {useNavigate} from "react-router-dom";

const CreateUserPage = () => {
    const addToastMessage = useToastMessagesStore((state) => state.addToastMessage);

    const { mutateAsync: createUser, isPending } = useCreateUser();
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const handleCreateUser = async (data: UserFormData) => {
        await createUser({
            StoreUserRequest: {
                ...data,
            }
        }, {
            onSuccess: async () => {
                await queryClient.invalidateQueries({
                    queryKey: QueryKeys.users._def
                });
                addToastMessage({
                    severity: 'success',
                    summary: 'User created',
                    detail: 'User has been created successfully',
                });
                await sleep(2000);
                navigate(url('users'));
            },
            onError: async (error) => {
                addToastMessage({
                    severity: 'error',
                    summary: 'User creation failed',
                    detail: `User creation failed ${error.message}`,
                });
            }
        });
    };

    return (
        <PageLayout>
            <UserForm
                onSubmit={handleCreateUser}
                isProcessing={isPending}
                onSubmitButtonLabel='Create user'
                onSubmitButtonDisabled={!can('edit:user')}
            />
        </PageLayout>
    );
};

export default CreateUserPage;